/* YSW Stock Countdown */
var yswStockCountDown = {
    selector: '.ysw-stock-countdown',
  	progressSelector: '.ysw-stock-countdown .progress-left',
  	numberSelector: '.ysw-stock-countdown .progress-count',
  	current: 10,
  	total: 25,
    start: 10,
    end: 4,
    speed: 8,
 	handle: '',
  	startJob: true,
  	timer:0,
  
    setCookie : function(name,value,days,domain,path) {
		if (days) {
			if (days == 0) {
				var expires = "";
			} else {
				var date = new Date();
				date.setTime(date.getTime()+(days*24*60*60*1000));
				var expires = "; expires="+date.toGMTString();
			}
		}
		else var expires = "";
		if (domain) {
			var cdomain = "; domain=" + domain;
		} else {
			var cdomain = "";
		}
		if (path) {
			var cpath = "; path=" + path;
		} else {
			var cpath = "; path=/";
		}
		document.cookie = name+"="+value+expires+cdomain+cpath;
	},
	eraseCookie : function (name, domain, path) {
		yswLib.setCookie(name,"",-1, domain, path);
	},
	getCookie : function (name) {
		var nameEQ = name + "=";
		var ca = document.cookie.split(';');
		for(var i=0;i < ca.length;i++) {
			var c = ca[i];
			while (c.charAt(0)==' ') c = c.substring(1,c.length);
			if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length,c.length);
		}
		return null;
	},
    setCurrentCount: function(){
      	var cookie = {}; 
      	if(yswStockCountDown.getCookie('yswStockCount') != null){
        	cookie = JSON.parse(yswStockCountDown.getCookie('yswStockCount'));
        }
      	cookie[yswStockCountDown.handle] = yswStockCountDown.current;
      	yswStockCountDown.setCookie('yswStockCount',JSON.stringify(cookie));
    },
    getCurrentCount: function(){
		var cookie = []; 
      	if(yswStockCountDown.getCookie('yswStockCount') != null){
        	cookie = JSON.parse(yswStockCountDown.getCookie('yswStockCount'));
        }
      	if (typeof cookie[yswStockCountDown.handle] !== 'undefined') {
      		yswStockCountDown.current = cookie[yswStockCountDown.handle];
        }
    },
    check:function(){
      if(yswStockCountDown.current == yswStockCountDown.end && yswStockCountDown.startJob == false){
        clearTimeout(yswStockCountDown.timer);
      } else {
        //Don't subtract when starting.
        if(yswStockCountDown.startJob == false){
        	yswStockCountDown.current--;
        }
       	var percentage = Math.ceil((yswStockCountDown.current / yswStockCountDown.total ) * 100);
        //$(yswStockCountDown.progressSelector).css('width',percentage+'%');
        $(yswStockCountDown.progressSelector).animate({ width: percentage+'%' }, 2000);
        $(yswStockCountDown.numberSelector).html(yswStockCountDown.current);
        yswStockCountDown.setCurrentCount();
      }
      yswStockCountDown.startJob = false;
    },

    go: function(){
      if($(yswStockCountDown.selector).length > 0){
        yswStockCountDown.handle = $(yswStockCountDown.selector).data('page');
        //Get Data if it exits and overwrite defaults
        if($(yswStockCountDown.selector).data('start') != ''){
          yswStockCountDown.total = ($(yswStockCountDown.selector).data('total') * 1);
        }
        
        if($(yswStockCountDown.selector).data('start') != ''){
          yswStockCountDown.start = ($(yswStockCountDown.selector).data('start') * 1);
          yswStockCountDown.current = ($(yswStockCountDown.selector).data('start') * 1);
        }
        if($(yswStockCountDown.selector).data('end') != ''){
          yswStockCountDown.end = ($(yswStockCountDown.selector).data('end') * 1);
        }
        //check if cookie exists
        if(yswStockCountDown.getCookie('yswStockCount') != null){
          yswStockCountDown.getCurrentCount();
        }
        if($(yswStockCountDown.selector).data('speed') != ''){
          yswStockCountDown.speed = ($(yswStockCountDown.selector).data('speed') * 1);
        }
        //convert speed into milliseconds
        $(yswStockCountDown.numberSelector).html(yswStockCountDown.current);
        yswStockCountDown.check();
        var milliseconds = yswStockCountDown.speed * 1000;
        yswStockCountDown.timer = setInterval(yswStockCountDown.check, milliseconds);
      }
    }   
};

$(document).ready(function(){
  yswStockCountDown.go();
});
/* END Stock Coundown */
